import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  marketplaceRepository,
  type Listing,
} from "@/repositories/marketplaceRepository";

/**
 * Put one minimum order of a listing in the basket.
 *
 * Shared by the grid card and the landing page's "Popular at …" row, so both
 * add the same quantity and both update the basket panel the same way.
 */
export function useAddToBasket(listing: Listing) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () =>
      marketplaceRepository.addToBasket({
        listing_id: listing.id,
        quantity: listing.minimum_order_quantity,
      }),
    // The basket endpoint returns the whole panel, so the totals update from the
    // response rather than from a second request.
    onSuccess: (basket) =>
      client.setQueryData(["marketplace", "basket"], basket),
  });
}
